module.exports = __webpack_public_path__ + "media/images/svgs/jobs/upload-06a6e8f2ecc49c2b151e3d16098dd0a1.svg";